import React, { useEffect, useState } from "react";
import ShowLocalChalans from "../Chalan/ShowLocalChalans";

import { fetchLocalchallans } from "../Chalan/ChalanList";
import { useNavigate } from "react-router-dom";
const Local = () => {
  const navigate = useNavigate();
  const [localchallan, setlocalchallan] = useState([]);
  useEffect(() => {
    const loadData = async () => {
      const data1 = await fetchLocalchallans();

      setlocalchallan(data1);
      localchallan.reverse();
    };
    loadData();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const itemsToDisplay = Object.values(localchallan)
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem)
    .map((item, index) => {
      return <ShowLocalChalans key={index} localchallan={item[1]} />;
    });
  return (
    <div style={{ margin: "auto" }}>
      <h2 style={{ textAlign: "center" }}>Freight Challans</h2>

      {/* {Object.values(localchallan)
        .reverse()
        .map((item, index) => {
          return (
            <ShowLocalChalans
              key={index}
              localchallan={item[1]}
            />
          );
        })} */}
      <div>
        {itemsToDisplay}
        <div style={{ textAlign: "center" }}>
          <button onClick={() => setCurrentPage(currentPage - 1)}>
            &laquo;
          </button>
          <button onClick={() => setCurrentPage(1)}>1</button>
          <button onClick={() => setCurrentPage(2)}>2</button>
          <button onClick={() => setCurrentPage(3)}>3</button>
          <button onClick={() => setCurrentPage(4)}>4</button>
          <button onClick={() => setCurrentPage(currentPage + 1)}>
            &raquo;
          </button>
        </div>
      </div>
      <div style={{ textAlign: "center" }}>
        <button
          onClick={() => {
            navigate("/dashbaord/invoice");
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default Local;
